import React from 'react';

import Avatar from '@atlaskit/avatar';

const AvatarHexagonExample = () => (
	<Avatar name="Rovo" appearance="hexagon" size="large" presence="online" />
);

export default AvatarHexagonExample;
